<template>
  <div class="search-filter-box p-6">
    <h4 class="fs-20 font-medium mb-4">
      Type
    </h4>

    <checkbox v-model="options.ecoventure">
      Programmes (year-round)
    </checkbox>
    <checkbox v-model="options.expedition">
      Expeditions (scheduled)
    </checkbox>
  </div>
</template>

<script>
import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox
  },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  methods: {
    loadOptions () {
      const filters = this.$store.state.filters
      const budgetValues = filters.categories.split(',')

      const options = {
        ecoventure: budgetValues.includes('ecoventure'),
        expedition: budgetValues.includes('expedition')
      }

      return options
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        let newValue = []
        if (options.ecoventure) newValue.push('ecoventure')
        if (options.expedition) newValue.push('expedition')

        this.$store.commit('setFilter', {
          name: 'categories',
          value: newValue.join(',')
        })
        this.$store.dispatch('loadProgrammes')
      }
    }
  }
}
</script>